export default "__VITE_ASSET__DNTlgR7S__"